import { render, staticRenderFns } from "./attributes-config-api-handler.vue?vue&type=template&id=73845988&"
import script from "./attributes-config-api-handler.vue?vue&type=script&lang=js&"
export * from "./attributes-config-api-handler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports